export default {
  superUserXStreams(state) {
    return state.superUserXStreams;
  },
  superUserXStreamRules(state) {
    return state.superUserXStreamRules;
  },
  superUserXStreamLastStatus(state) {
    return state.superUserXStreamLastStatus;
  },
};
